export default "__VITE_ASSET__cc8865ad__"